(ns manage.export-display-modal.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :page.export-display/copy-link
  (fn [_ [_ link-tag]]
    {:content->clipboard {:content link-tag}}))
